import { gql } from '@apollo/client';

const IS_ICOR_STUDY_ACTIVE_QUERY = gql`
  query isIcorStudyActive($deviceId: String!) {
    isIcorStudyActive(deviceId: $deviceId)
  }
`;

export default IS_ICOR_STUDY_ACTIVE_QUERY;
